export default __webpack_public_path__ + "afe88b78afb10e6508240ec5050af222.png";